/**
 * Function to find A$ values and replace them with the active currency symbol and converted amount
 */
function replaceAjjayaValuesWithActiveCurrency() {
  console.log('Replacing A$ values with active currency...');
  
  try {
    // Check if Shopify.currency exists and get necessary information
    if (!window.Shopify || !window.Shopify.currency) {
      console.error('Shopify.currency not found. Cannot convert values.');
      return null;
    }
    
    const rate = window.Shopify.currency.rate;
    const activeCurrency = window.Shopify.currency.active;
    
    if (!rate) {
      console.error('Shopify.currency.rate not found. Cannot convert values.');
      return null;
    }
    
    if (!activeCurrency) {
      console.error('Shopify.currency.active not found. Cannot determine currency symbol.');
      return null;
    }
    
    console.log(`Found active currency: ${activeCurrency}, rate: ${rate}`);
    
    // Determine currency symbol based on active currency
    let currencySymbol = getCurrencySymbol(activeCurrency);
    console.log(`Using currency symbol: ${currencySymbol}`);
    
    // Get all text nodes in the document
    const textNodes = [];
    const walker = document.createTreeWalker(
      document.body,
      NodeFilter.SHOW_TEXT,
      null,
      false
    );
    
    let node;
    while (node = walker.nextNode()) {
      if (node.nodeValue.includes('A$')) {
        textNodes.push(node);
      }
    }
    
    console.log(`Found ${textNodes.length} text nodes containing A$`);
    
    // Process each text node containing A$
    let totalUpdated = 0;
    const updatedValues = [];
    
    textNodes.forEach(textNode => {
      const originalText = textNode.nodeValue;
      let newText = originalText;
      let updated = false;
      
      // Find all A$ values in this text node
      const ajjayaRegex = /A\$\s*([\d,.]+)/g;
      let match;
      let lastIndex = 0;
      
      while ((match = ajjayaRegex.exec(originalText)) !== null) {
        // Parse the original value
        const rawValue = parseFloat(match[1].replace(/,/g, ''));
        
        // Convert using Shopify.currency.rate
        const convertedValue = rawValue * rate;
        
        // Format with 2 decimal places
        const formattedConvertedValue = convertedValue.toFixed(2);
        
        // Create replacement text with converted value and currency symbol
        const originalMatch = match[0]; // e.g., "A$ 125.50"
        const replacementText = `${currencySymbol}${formattedConvertedValue}`;
        
        // Replace in the new text
        newText = newText.substring(0, match.index + lastIndex) + 
                 replacementText + 
                 newText.substring(match.index + originalMatch.length + lastIndex);
        
        // Adjust lastIndex for the next replacement
        lastIndex += replacementText.length - originalMatch.length;
        
        // Track updated values
        updatedValues.push({
          originalA$: originalMatch,
          rawValue: rawValue,
          convertedValue: convertedValue,
          replacedWith: replacementText
        });
        
        updated = true;
      }
      
      // Update the text node if changes were made
      if (updated) {
        textNode.nodeValue = newText;
        totalUpdated++;
      }
    });
    
    console.log(`Updated ${totalUpdated} text nodes. Replaced A$ values with ${currencySymbol}`);
    console.log('Updated values:', updatedValues);
    
    return {
      activeCurrency: activeCurrency,
      currencySymbol: currencySymbol,
      rate: rate,
      totalUpdated: totalUpdated,
      values: updatedValues
    };
    
  } catch (error) {
    console.error('Error replacing A$ values:', error);
    return null;
  }
}

/**
 * Get currency symbol based on currency code
 */
function getCurrencySymbol(currencyCode) {
  const currencySymbols = {
    'USD': '$',
    'EUR': '€',
    'GBP': '£',
    'JPY': '¥',
    'CAD': 'C$',
    'AUD': 'A$',
    'INR': '₹',
    'CNY': '¥',
    'BRL': 'R$',
    'RUB': '₽',
    'KRW': '₩',
    'MXN': 'Mex$',
    'SGD': 'S$',
    'NZD': 'NZ$',
    'CHF': 'Fr',
    'HKD': 'HK$',
    'SEK': 'kr',
    'NOK': 'kr',
    'DKK': 'kr',
    'PLN': 'zł',
    'ZAR': 'R'
  };
  
  return currencySymbols[currencyCode] || currencyCode;
}

/**
 * Alternative approach that updates elements containing A$ values
 */
function replaceAjjayaValuesWithActiveCurrencyAlternative() {
  console.log('Alternative approach: Replacing A$ in HTML elements...');
  
  try {
    // Check if Shopify.currency exists and get necessary information
    if (!window.Shopify || !window.Shopify.currency) {
      console.error('Shopify.currency not found. Cannot convert values.');
      return null;
    }
    
    const rate = window.Shopify.currency.rate;
    const activeCurrency = window.Shopify.currency.active;
    
    if (!rate) {
      console.error('Shopify.currency.rate not found. Cannot convert values.');
      return null;
    }
    
    if (!activeCurrency) {
      console.error('Shopify.currency.active not found. Cannot determine currency symbol.');
      return null;
    }
    
    // Determine currency symbol
    let currencySymbol = getCurrencySymbol(activeCurrency);
    
    // Find all elements containing A$
    const elementsWithA$ = Array.from(document.querySelectorAll('*')).filter(el => 
      (el.textContent || '').includes('A$') && 
      !el.querySelector('*') // Only get the most specific elements (no children)
    );
    
    console.log(`Found ${elementsWithA$.length} elements containing A$`);
    
    // Process each element
    let totalUpdated = 0;
    const updatedValues = [];
    
    elementsWithA$.forEach(element => {
      const originalText = element.textContent;
      let newHTML = element.innerHTML;
      let updated = false;
      
      // Find all A$ values in this element
      const ajjayaRegex = /A\$\s*([\d,.]+)/g;
      let match;
      
      while ((match = ajjayaRegex.exec(originalText)) !== null) {
        // Parse the original value
        const rawValue = parseFloat(match[1].replace(/,/g, ''));
        
        // Convert using Shopify.currency.rate
        const convertedValue = rawValue * rate;
        
        // Format with 2 decimal places
        const formattedConvertedValue = convertedValue.toFixed(2);
        
        // Create replacement text with converted value and currency symbol
        const originalMatch = match[0]; // e.g., "A$ 125.50"
        const replacementText = `${currencySymbol}${formattedConvertedValue}`;
        
        // Replace in the HTML
        newHTML = newHTML.replace(originalMatch, replacementText);
        
        // Track updated values
        updatedValues.push({
          originalA$: originalMatch,
          rawValue: rawValue,
          convertedValue: convertedValue,
          replacedWith: replacementText
        });
        
        updated = true;
      }
      
      // Update the element if changes were made
      if (updated) {
        element.innerHTML = newHTML;
        totalUpdated++;
      }
    });
    
    console.log(`Updated ${totalUpdated} elements. Replaced A$ values with ${currencySymbol}`);
    console.log('Updated values:', updatedValues);
    
    return {
      activeCurrency: activeCurrency,
      currencySymbol: currencySymbol,
      rate: rate,
      totalUpdated: totalUpdated,
      values: updatedValues
    };
    
  } catch (error) {
    console.error('Error replacing A$ values (alternative):', error);
    return null;
  }
}

/**
 * Run both approaches to ensure all A$ values are replaced
 */
function replaceAllAjjayaValues() {
  console.log('Starting to replace all A$ values with active currency...');
  
  // Try both methods
  const method1Results = replaceAjjayaValuesWithActiveCurrency();
  
  // If the first method didn't find anything or had no updates, try the alternative
  if (!method1Results || method1Results.totalUpdated === 0) {
    console.log('First method did not update any values. Trying alternative method...');
    return replaceAjjayaValuesWithActiveCurrencyAlternative();
  }
  
  return method1Results;
}

// Run the function to replace all A$ values with active currency
document.addEventListener('StartAsyncLoading',function(event){
  const widgetIntervalLoyality = setInterval( () => {
    console.log(document.querySelectorAll(".c-embeddedEarningRules-cardContainer .c-actionCard").length,"dddddd");
    if(document.querySelectorAll(".c-embeddedEarningRules-cardContainer .c-actionCard").length > 0){
      if(Shopify.currency.active !== "AUD"){
          replaceAllAjjayaValues();
        }
      clearInterval(widgetIntervalLoyality);
    }
  },5000);
 
  
});